import { Guid } from "@/types"
import Notification, { IGetNotification } from "./Notification"

export interface IGetNotificationStoringCompletedDto extends IGetNotification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string
}

export default class NotificationStoringCompleted extends Notification {
    reservationId: Guid
    reservationNumber?: string
    shippingOrderId?: Guid
    shippingOrderNumber?: string

    constructor(dto: IGetNotificationStoringCompletedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.shippingOrderId = dto.shippingOrderId
        this.shippingOrderNumber = dto.shippingOrderNumber
    }
}
